module.exports = __webpack_public_path__ + "img/chr_ts_19.c49a7ff1.png";